import { LintError, TypedError } from '@rehaje/errors'

import type { Locales } from '@rehaje/errors'

export abstract class LintJavaScriptError extends LintError {
  constructor(public originError: Error) {
    super(originError.name, originError.message)
  }
}

export class LintJavaScriptCompileError extends LintJavaScriptError {
  static override locales: Locales = {
    'en-US': '%s %s',
    'zh-CN': '%s %s',
    'zh-HK': '%s %s'
  }

  override name = 'LintJavaScriptCompileError' as const
}

export class LintJavaScriptRuntimeError extends LintJavaScriptError {
  static override locales: Locales = {
    'en-US': '%s %s',
    'zh-CN': '%s %s',
    'zh-HK': '%s %s'
  }

  override name = 'LintJavaScriptRuntimeError' as const
}

export class LintJavaScriptSyntaxError extends LintJavaScriptError {
  static override locales: Locales = {
    'en-US': '%s %s',
    'zh-CN': '%s %s',
    'zh-HK': '%s %s'
  }

  override name = 'LintJavaScriptSyntaxError' as const
}

export function registerJavaScriptErrorsSideEffect() {
  TypedError.registerErrorLocales({
    LintJavaScriptCompileError,
    LintJavaScriptRuntimeError,
    LintJavaScriptSyntaxError
  })
}

registerJavaScriptErrorsSideEffect()
